export const GRID_TEMPLATE = '110px 1fr 110px 240px 170px';

export const APPROVED_STORAGE_KEY = 'novala.approvedCategorize';
export const DISMISSED_STORAGE_KEY = 'novala.dismissedCategorize';
export const OVERRIDE_STORAGE_KEY = 'novala.categorizeOverrides';

// Pool of category options for the dropdown. In production this comes from
// the user's chart of accounts (Expense + Income types).
export const CATEGORY_OPTIONS: Array<{ id: string; name: string }> = [
  { id: 'cat-office', name: 'Office supplies' },
  { id: 'cat-general', name: 'General expenses' },
  { id: 'cat-printing', name: 'Printing and stationery' },
  { id: 'cat-shop', name: 'Shop supplies' },
  { id: 'cat-misc', name: 'Miscellaneous' },
  { id: 'cat-sw', name: 'Software and apps' },
  { id: 'cat-benefits', name: 'Benefits reimbursement' },
  { id: 'cat-vehicle', name: 'Vehicle expenses' },
  { id: 'cat-transfer', name: 'Owner transfer' },
  { id: 'cat-grant', name: 'Grant income' },
  { id: 'cat-rent', name: 'Rent and lease' },
  { id: 'cat-utilities', name: 'Utilities' },
];